// Сеты S1–S8 для показа (SCR-SETS, E05-T07): названия, состав и бонусы порогов — ГД 02 §6, состав по ID —
// каталог предметов (Р-47, seed/items.ts). Бонусы здесь — только подписи; в бою их считает сервер.
// Число частей — канон §8: S1 — 3, S2/S3/S6 — 4, S4/S5 — 5, S7/S8 — 6.
import type { Slot } from './types.js';

export interface SetInfo {
  id: string;
  name: string;
  rarity: 'good' | 'rare' | 'epic' | 'legendary';
  level: number;
  pieces: string[];
  /** Пороги и подписи бонусов: «2», «3», полный комплект. */
  tiers: { n: number; text: string }[];
  source: string;
}

export const SETS: readonly SetInfo[] = [
  { id: 'S1', name: 'Слесарь-универсал', rarity: 'good', level: 5, pieces: ['EQ-JACKET-04', 'EQ-PANTS-04', 'EQ-TOOL-04'],
    tiers: [{ n: 2, text: '«Удар» +8%' }, { n: 3, text: 'перезарядка «Броска ключа» 2 → 1' }], source: 'Боссы гаражного кооператива (D1)' },
  { id: 'S2', name: 'Сварщик', rarity: 'rare', level: 9, pieces: ['EQ-HEAD-05', 'EQ-JACKET-06', 'EQ-TOOL-06', 'EQ-ACC-06'],
    tiers: [{ n: 2, text: 'особые приёмы +10%' }, { n: 3, text: 'первый «Строительный фен» в заходе без солярки' }, { n: 4, text: '«Строительный фен» +25% и прогревает' }], source: 'Боссы гаражного кооператива (D1)' },
  { id: 'S3', name: 'Автоэлектрик', rarity: 'rare', level: 13, pieces: ['EQ-HEAD-09', 'EQ-PANTS-09', 'EQ-SHOES-08', 'EQ-ACC-10'],
    tiers: [{ n: 2, text: 'крит +3 п. п.' }, { n: 3, text: 'разъедание «Химии» +50%' }, { n: 4, text: 'крит снимает ход перезарядки со случайного приёма' }], source: 'Боссы второго района (D2)' },
  { id: 'S4', name: 'Жестянщик', rarity: 'rare', level: 16, pieces: ['EQ-HEAD-10', 'EQ-JACKET-10', 'EQ-PANTS-10', 'EQ-SHOES-09', 'EQ-TOOL-10'],
    tiers: [{ n: 2, text: 'защита +8%' }, { n: 3, text: 'здоровье +10%' }, { n: 5, text: 'первый удар босса −50%; «Удар» +10%' }], source: 'Боссы второго района (D2)' },
  { id: 'S5', name: 'Моторист', rarity: 'epic', level: 24, pieces: ['EQ-JACKET-15', 'EQ-PANTS-15', 'EQ-SHOES-15', 'EQ-TOOL-15', 'EQ-ACC-15'],
    tiers: [{ n: 2, text: 'атака +6%' }, { n: 3, text: '«Полный бак» ×1,35' }, { n: 5, text: 'каждый 4-й ход «Удар» бьёт ×2' }], source: 'Боссы третьего района (D3)' },
  { id: 'S6', name: 'Шиномонтаж', rarity: 'rare', level: 21, pieces: ['EQ-HEAD-14', 'EQ-JACKET-14', 'EQ-SHOES-13', 'EQ-TOOL-14'],
    tiers: [{ n: 2, text: 'уклон +4 п. п.' }, { n: 3, text: 'после уклонения следующий приём +30%' }, { n: 4, text: 'перезарядка «Домкрата» 5 → 3' }], source: 'Боссы третьего района (D3)' },
  { id: 'S7', name: 'Дальнобойщик', rarity: 'epic', level: 28, pieces: ['EQ-HEAD-18', 'EQ-JACKET-18', 'EQ-PANTS-18', 'EQ-SHOES-18', 'EQ-TOOL-18', 'EQ-ACC-18'],
    tiers: [{ n: 2, text: 'здоровье +8%' }, { n: 3, text: 'урон в общих режимах +10%' }, { n: 6, text: '«второе дыхание»: с 7-го раунда урон +15%; износ машины −20%' }], source: 'Мировой рейд, ступень «передовик», и топы' },
  { id: 'S8', name: 'Председатель', rarity: 'legendary', level: 30, pieces: ['EQ-HEAD-19', 'EQ-JACKET-19', 'EQ-PANTS-19', 'EQ-SHOES-19', 'EQ-TOOL-19', 'EQ-ACC-19'],
    tiers: [{ n: 2, text: 'атака и здоровье +5%' }, { n: 3, text: 'Харизма +20' }, { n: 6, text: 'все приёмы +12%; аура кооперативу +3% урона' }], source: 'Жетоны председателя, Лавка Семёныча, легендарные B12, топы' },
];

const SLOT_BY_CODE: Record<string, Slot> = { HEAD: 'head', JACKET: 'jacket', PANTS: 'pants', SHOES: 'shoes', TOOL: 'tool', ACC: 'accessory' };

export function slotOf(defId: string): Slot {
  return SLOT_BY_CODE[defId.split('-')[1] ?? ''] ?? 'accessory';
}

/** Часть S8 для слота (`EQ-*-19`, ГД 02 §6.2). */
export function s8Piece(slot: Slot): string {
  return SETS.find((s) => s.id === 'S8')!.pieces.find((p) => slotOf(p) === slot)!;
}
